<template>
  <el-main class="main-con el-main">
    <el-tabs class="bg-purple message_tab_style" v-model="messageType" style="min-height:400px">
      <el-tab-pane name="trade">
                <span slot="label"><el-badge :value="1" class="item tabs-head-title">
                  <el-button size="small">业务消息</el-button>
                </el-badge></span>
        <ul class="note-mesg-list">
          <li>
            <i></i>
            系统上线通知
            <span>2020-5-20</span>
          </li>
        </ul>

      </el-tab-pane>
      <el-tab-pane name="notice" style="min-height:400px">
                <span slot="label"><el-badge :value="0" class="item tabs-head-title">
                  <el-button size="small">系统公告</el-button>
                </el-badge></span>
        <div style="text-align:center;margin:80px 0">暂无公告</div>
      </el-tab-pane>
      <el-tab-pane name="news" style="min-height:400px">
                <span slot="label"><el-badge :value="0" class="item tabs-head-title">
                  <el-button size="small">升级公告</el-button>
                </el-badge></span>
        <div style="text-align:center;margin:80px 0">暂无公告</div>
      </el-tab-pane>
    </el-tabs>
  </el-main>
</template>

<script>
  export default {
    name: "MessageList",
    data() {
      return {
        messageType: 'trade'
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/Message/MessageList.vue